/**
 * The glossary registry.
 *
 * `/glossary` and `/glossary/<slug>` — v1's own addresses, and unlike the
 * comparison pages these survive the router's ranking rules without a fight,
 * because they were already two segments deep. Nothing here needs a redirect.
 */

import type { ContentLang } from "@fazly/shared/contentLang";

import { en } from "./en";
import type { GlossaryBundle, GlossarySlug } from "./types";
import { GLOSSARY_SLUGS } from "./types";

export function glossaryPath(
  slug: GlossarySlug,
  lang: ContentLang = "en",
): string {
  return lang === "en" ? `/glossary/${slug}` : `/${lang}/glossary/${slug}`;
}

export function glossaryIndexPath(lang: ContentLang = "en"): string {
  return lang === "en" ? "/glossary" : `/${lang}/glossary`;
}

export function glossarySlugOf(raw: string): GlossarySlug | null {
  return (GLOSSARY_SLUGS as readonly string[]).includes(raw)
    ? (raw as GlossarySlug)
    : null;
}

const LOADERS: Record<ContentLang, () => Promise<GlossaryBundle>> = {
  en: async () => en,
  de: () => import("./de").then((m) => m.de),
  tr: () => import("./tr").then((m) => m.tr),
  pt: () => import("./pt").then((m) => m.pt),
  es: () => import("./es").then((m) => m.es),
};

export function loadGlossary(lang: ContentLang): Promise<GlossaryBundle> {
  return LOADERS[lang]();
}

export type { GlossaryBundle, GlossarySlug };
export { GLOSSARY_SLUGS };
